import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcLogKey, RpcLogRecord } from './rpc-log-model';

export class RpcLogClient {
    /**
     * The log command.
     *
     * @param data the RpcLogRecord object.
     * @return Promise<void> the promise object.
     */
    public static log(rpc: Rpc, data: RpcLogRecord): Promise<void> {
        return RpcInboundClient.call(rpc, RpcLogKey.command, RpcLogKey.version, data);
    }
}
